import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { MarketplaceHeader } from '../components/layout/MarketplaceHeader';
import { Footer } from '../components/layout/Footer';
import { CartItem } from '../components/restaurant/CartItem';
import { useCart } from '../lib/cart';
import { formatCurrency } from '../lib/utils';
import { Button } from '../components/ui/Button';
import { EmptyState } from '../components/ui/EmptyState';
import { ShoppingBag, ArrowLeft, Store } from 'lucide-react';
export function CartPage() {
  const navigate = useNavigate();
  const {
    cart,
    updateQuantity,
    removeItem,
    getTotal,
    clearCart
  } = useCart();
  const subtotal = getTotal();
  // In a real app, delivery fee would be calculated based on distance/settings
  const deliveryFeeEstimate = cart.items.length > 0 ? 1500 : 0;
  const total = subtotal + deliveryFeeEstimate;
  if (cart.items.length === 0) {
    return <div className="min-h-screen flex flex-col bg-brand-offwhite" data-id="element-1078">
        <MarketplaceHeader data-id="element-1079" />
        <main className="flex-1 flex items-center justify-center py-12" data-id="element-1080">
          <EmptyState icon={ShoppingBag} title="Tu carrito está vacío" description="Aún no has agregado ningún producto a tu pedido. ¡Explora los restaurantes y encuentra algo delicioso!" actionLabel="Explorar restaurantes" onAction={() => navigate('/restaurants')} data-id="element-1081" />
        </main>
        <Footer data-id="element-1082" />
      </div>;
  }
  return <div className="min-h-screen flex flex-col bg-brand-offwhite" data-id="element-1083">
      <MarketplaceHeader data-id="element-1084" />

      <main className="flex-1 max-w-3xl mx-auto w-full px-4 sm:px-6 py-8" data-id="element-1085">
        <div className="flex items-center justify-between mb-8" data-id="element-1086">
          <div className="flex items-center gap-4" data-id="element-1087">
            <button onClick={() => navigate(-1)} className="p-2 -ml-2 text-gray-400 hover:text-gray-900 rounded-full hover:bg-gray-50 transition-colors" data-id="element-1088">
              <ArrowLeft className="w-6 h-6" data-id="element-1089" />
            </button>
            <h1 className="text-3xl font-bold text-gray-900" data-id="element-1090">Tu Pedido</h1>
          </div>
          <button onClick={clearCart} className="text-sm font-medium text-red-500 hover:text-red-600 transition-colors" data-id="element-1091">
            Vaciar
          </button>
        </div>

        <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden mb-8" data-id="element-1092">
          <div className="bg-gray-50 px-6 py-4 border-b border-gray-100 flex items-center gap-3" data-id="element-1093">
            <Store className="w-5 h-5 text-gray-500" data-id="element-1094" />
            <span className="font-semibold text-gray-900" data-id="element-1095">
              {cart.restaurantName}
            </span>
          </div>

          <div className="px-6 py-2" data-id="element-1096">
            {cart.items.map(item => <CartItem key={item.id} item={item} onUpdateQuantity={updateQuantity} onRemove={removeItem} data-id="element-1097" />)}
          </div>
        </div>

        <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-6 mb-8" data-id="element-1098">
          <h3 className="text-lg font-bold text-gray-900 mb-4" data-id="element-1099">Resumen</h3>

          <div className="space-y-3 text-sm text-gray-600 mb-6" data-id="element-1100">
            <div className="flex justify-between" data-id="element-1101">
              <span data-id="element-1102">Subtotal</span>
              <span className="font-medium text-gray-900" data-id="element-1103">
                {formatCurrency(subtotal)}
              </span>
            </div>
            <div className="flex justify-between" data-id="element-1104">
              <span data-id="element-1105">Costo de envío (Estimado)</span>
              <span className="font-medium text-gray-900" data-id="element-1106">
                {formatCurrency(deliveryFeeEstimate)}
              </span>
            </div>
            <div className="pt-3 border-t border-gray-100 flex justify-between text-lg font-bold text-gray-900" data-id="element-1107">
              <span data-id="element-1108">Total Estimado</span>
              <span data-id="element-1109">{formatCurrency(total)}</span>
            </div>
          </div>

          <Button size="lg" fullWidth className="text-lg shadow-xl" onClick={() => navigate('/checkout')} data-id="element-1110">
            Continuar al Pago
          </Button>

          <p className="text-center text-xs text-gray-500 mt-4" data-id="element-1111">
            El costo de envío final se calculará en el siguiente paso.
          </p>
        </div>
      </main>

      <Footer data-id="element-1112" />
    </div>;
}